import{getAugmentedNamespace as e}from"./_commonjsHelpers.js";import*as o from"../node_modules/tabbable/dist/index.esm.js";var s=e(o);export{s as default};
